import PropTypes from 'prop-types';
import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
  PDFViewer,
  Note,
  Layp,
  BlobProvider,
  pdf
} from '@react-pdf/renderer';
import indexFinder from '../utils/indexFinder';
import { getBaseURL, getAPIURL } from '../utils/envGetter';

const PDFRendererForTTE = ({ Header, BodyPermohonan, informations, decoded, layanan, preview }) => {
  const data = '13';

  function PenandaTangan({ informations, decoded, layanan, preview }) {
    const recommenderNama =
      layanan.meta?.data_permohonan?.metadata?.answers?.nama_kepala_dinas || '-';
    const recommenderNIP =
      layanan.meta?.data_permohonan?.metadata?.answers?.nip_kepala_dinas || '-';

    function Approver({ informations, decoded, layanan }) {
      return (
        <View
          style={{
            width: '50%',
            paddingTop: 10,
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <View
            style={{
              height: 50,
              alignItems: 'center',
              paddingBottom: 10,
              flexDirection: 'column',
              justifyContent: 'flex-end'
            }}
          >
            <Text
              style={{
                fontSize: 9,
                fontFamily: 'Bookos',
                fontWeight: 'normal',
                textAlign: 'center'
              }}
            >
              Kepala
            </Text>

            {/* <Text
              style={{
                fontSize: 9,
                fontFamily: 'Bookos',
                fontWeight: 'normal',
                textAlign: 'center'
              }}
            >
              {recommenderInstansi}
            </Text> */}
          </View>

          {preview ? (
            <View style={{ paddingBottom: 5 }}>
              {decoded.modeTandaTangan === 'tte' ? (
                <Image
                  allowDangerousPaths
                  src="https://peladen.jogjaprov.go.id/static/qr_draft.png"
                  style={{ width: 75, height: 75 }}
                />
              ) : (
                <View style={{ width: 75, height: 75 }} />
              )}
            </View>
          ) : (
            <View style={{ paddingBottom: 5 }}>
              {/* decoded.modeTandaTangan === 'tte' disable remove qrcode */}
              {decoded.modeTandaTangan === 'tte' ? (
                <Image
                  allowDangerousPaths
                  src={`${getAPIURL()}/qrcodes?id=${
                    layanan?.meta?.[
                      decoded.selectedRequirement.type
                    ]?.metadata?.qr_code_path?.split('/')[5]
                  }&year=${
                    layanan?.meta?.[
                      decoded.selectedRequirement.type
                    ]?.metadata?.qr_code_path?.split('/')[3]
                  }&month=${
                    layanan?.meta?.[
                      decoded.selectedRequirement.type
                    ]?.metadata?.qr_code_path?.split('/')[4]
                  }`}
                  style={{ width: 75, height: 75 }}
                />
              ) : (
                <View style={{ width: 75, height: 75 }} />
              )}
            </View>
          )}

          <Text
            style={{
              fontSize: 9,
              fontFamily: 'Bookos',
              fontWeight: 'normal',
              textDecoration: 'underline',
              textAlign: 'center'
            }}
          >
            {recommenderNama}
          </Text>
          <Text
            style={{
              fontSize: 9,
              fontFamily: 'Bookos',
              fontWeight: 'normal',
              textAlign: 'center'
            }}
          >
            NIP. {recommenderNIP}
          </Text>
        </View>
      );
    }

    return (
      <View
        break
        style={{
          paddingTop: 10,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <View
          style={{
            width: '50%',
            paddingTop: 10,
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        />

        <Approver informations={informations} decoded={decoded} layanan={layanan} />
      </View>
    );
  }
  return (
    <View>
      <View>{Header}</View>
      <View>{BodyPermohonan}</View>
      <View>
        <PenandaTangan
          informations={informations}
          decoded={decoded}
          layanan={layanan}
          preview={preview}
        />
      </View>
    </View>
  );
};

export default PDFRendererForTTE;
